"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const CustomButton_vue_1 = __importDefault(require("../../../components/backend/CustomButton.vue"));
const Card_vue_1 = __importDefault(require("../../../components/backend/Card/Card.vue"));
const CardStatus_vue_1 = __importDefault(require("../../../components/backend/Card/CardComponents/CardStatus.vue"));
const CardBlock_vue_1 = __importDefault(require("../../../components/backend/Card/CardComponents/CardBlock.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ServiceElement',
    props: {
        serviceId: {
            type: Number,
            required: true,
        },
        serviceName: {
            type: String,
            required: true,
        },
        isActive: {
            type: Boolean,
            required: true,
        },
        duration: {
            type: Number,
            required: true,
        },
        assignedLocations: {
            type: Array,
            required: true,
        },
        price: {
            type: Number,
            required: true,
        },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_font_awesome_icon = (0, vue_2.resolveComponent)("font-awesome-icon");
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Card_vue_1.default, {
                title: __props.serviceName + ' (BHP price: ' + __props.price + ' FT)'
            }, {
                default: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createVNode)(CardStatus_vue_1.default, { active: __props.isActive }, null, 8, ["active"]),
                    (0, vue_2.createVNode)(CardBlock_vue_1.default, {
                        title: _ctx.$trans('type', 'Type', 'service_list'),
                        value: _ctx.$trans('typre_service', 'Tyre Service', 'service_list')
                    }, null, 8, ["title", "value"]),
                    (0, vue_2.createVNode)(CardBlock_vue_1.default, {
                        title: _ctx.$trans('duration', 'Duration', 'service_list'),
                        value: __props.duration + ' ' + _ctx.$trans('minute', 'minute', 'service_list')
                    }, null, 8, ["title", "value"]),
                    (0, vue_2.createVNode)(CardBlock_vue_1.default, {
                        title: _ctx.$trans('assigned_locations', 'Assigned locations', 'service_list'),
                        value: __props.assignedLocations
                    }, null, 8, ["title", "value"]),
                    (0, vue_2.createVNode)(CustomButton_vue_1.default, {
                        to: { name: 'service_edit', params: { id: __props.serviceId } },
                        "default-icon": false,
                        "btn-type": "transparent"
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_font_awesome_icon, {
                                class: "icon",
                                icon: ['far', 'pen-to-square']
                            }),
                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.$trans("edit_service", "Edit Service", "service_list")), 1)
                        ]),
                        _: 1
                    }, 8, ["to"])
                ]),
                _: 1
            }, 8, ["title"]));
        };
    }
});
